import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Card, Link, Typography, Stack, Button, InputAdornment, TextField } from '@mui/material';
import Grid from '@mui/material/Grid'
import { useForm, Controller } from "react-hook-form";
import { showSuccess, showError } from '../../../utils/toast';
// import blankImg from "../../../../public/assets/blank-img.jpg"
// Icons
import FastfoodOutlinedIcon from '@mui/icons-material/FastfoodOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';

import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { styled } from '@mui/material/styles';
import Label from '../../../components/label';

// api
import { apiCallSecureGet, apiPostSecure, apiDeleteSecureWithBody, apiUrl } from '../../../utils/api';
import { useGetCategoryQuery, useGetSubCategoryQuery } from '../../../redux/services/common/Common';
import { useGetSallerLogoApiMutation } from '../../../redux/services/seller/sellerInfo';

const DataLogo = ({ name, path }) => {
    const url = `${apiUrl.Logo}${path}`;
    console.log('logo', url);
    return (
        <img alt={name} src={url} style={{ height: "100%", width: "100%" }}
        />

    )
}

export const LogoUpdate = (props) => {
    const { sellerLogo, setSellerLogo, sellerid, setload } = props;
    const [LogoUpdate, ShopLogo] = useGetSallerLogoApiMutation()
    // const [sellerLogo, setSellerLogo] = useState('')

    const { register, handleSubmit, setValue, watch, control, reset, formState: { errors } } = useForm();

    const onLogoUpdate = async (data, event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('id', sellerid?.id);
        console.log('id', sellerid?.id)
        formData.append('logo', data.logo);
        formData.append('req', "logo");
        console.log('logo', sellerid?.logo)



        try {
            const logoUpload = await LogoUpdate(formData)
            console.log("logoUpload", logoUpload)
            setSellerLogo(logoUpload);
            // setLoadMenu(true);
            setSellerLogo(null);
            reset()
            setload()

        }
        catch (error) {
            console.log("Error fetching data:", error);

        }
    }

    useEffect(() => {
        if (ShopLogo.isSuccess) {
            showSuccess(" Logo Updated !")
            ShopLogo.reset()
        }
        if (ShopLogo.isError) {
            showError(ShopLogo.error.data.msg)
            ShopLogo.reset()

        }
    }, [ShopLogo,])



    return (
        <>
            <Dialog
                open={sellerLogo != null}
                onClose={() => { setSellerLogo(null) }}
            >
                <DialogTitle id="alert-dialog-title">
                    <Typography variant='h4'>Logo Update</Typography>
                    <hr />
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {/* <Typography variant='h6'>{message?.current}</Typography> */}
                    </DialogContentText>
                    <br />
                    <br />
                    <form id="logo-form" onSubmit={handleSubmit(onLogoUpdate)}>

                        <Grid container spacing={1} mb={2}>

                            <Grid item xs={12} sm={6} md={4} >
                                <Controller
                                    name="logo" // Change this to the correct field name
                                    control={control}
                                    defaultValue={null}
                                    render={({ field }) => (
                                        <div className="container">
                                            <div className="header">
                                                {field.value ? (
                                                    <img
                                                        alt='img'
                                                        src={typeof field.value === 'string' ? field.value : URL.createObjectURL(field.value)}
                                                        style={{ height: "100%", width: "100%" }}
                                                    />
                                                ) : (
                                                    !sellerid?.logo ? <img alt='img' src="https://img.freepik.com/free-vector/illustration-cloud-upload_53876-35883.jpg?w=2000" style={{ height: "100%", width: "100%" }} /> : <DataLogo path={sellerid?.logo} />
                                                )}
                                            </div>
                                            <label htmlFor="file" className="footer">
                                                <svg fill="#000000" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0" /><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" /><g id="SVGRepo_iconCarrier"><path d="M15.331 6H8.5v20h15V14.154h-8.169z" /><path d="M18.153 6h-.009v5.342H23.5v-.002z" /></g></svg>
                                                <p> Upload Photo</p>

                                                <input
                                                    id="file"
                                                    type="file"
                                                    name="logo"
                                                    {...register('logo')}
                                                    onChange={(e) => field.onChange(e.target.files[0])}
                                                />
                                            </label>
                                        </div>
                                    )}
                                />
                            </Grid>
                        </Grid>

                        <DialogActions>
                            <Button type="submit" >
                                Update
                            </Button>
                            <Button onClick={() => { setSellerLogo(null) }}>Cancel</Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog >
        </>
    );
}




